var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_993_2561",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 107,
    height: 107
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.261719,
    y: 0.233398,
    width: 105.904,
    height: 105.904,
    rx: 10,
    fill: "url(#pattern0_993_2561)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_993_2561)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.0409,
    cy: 60.2183,
    rx: 85.2196,
    ry: 71.5679,
    fill: "#409A94"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_993_2561",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_993_2561",
    transform: "scale(0.0078125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_993_2561",
    width: 128,
    height: 128,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCap);
export default __webpack_public_path__ + "static/media/cap.70e55198200e0065746da1a8ebbf5a9e.svg";
export { ForwardRef as ReactComponent };